import {Brand} from '../Brand';
import {sextyNineBase} from './sextyNineBase';
import {SextyNineLogo} from './SextyNineLogo';

export const sextyNine: Brand = {
  ...sextyNineBase,
  assets: {
    logo: SextyNineLogo,
  },
};
